import { calculateDistance } from './calculateDistance.js';

export const sortByDistance = (businesses, refLat, refLng) => {
    return businesses
        .map(business => ({
            ...business,
            distance: business.distance || calculateDistance(refLat, refLng, business.lat, business.lng),
        }))
        .sort((a, b) => a.distance - b.distance);
};
